<template>
  <div class="header" @touchmove.prevent>
    <div class="leftBox" @click="toShort">
      <img class="logo" :src="$utils.getPng('icon-short-logoh')" />
      <img class="title" :src="$utils.getPng('icon-short-h5n')" />
    </div>
    <div class="user" v-if="$store.state.isLogin == 1" @click="show = !show">
      <img class="logo" :src="$store.state.userInfo.logo" />
      <span class="font1">{{ $store.state.userInfo.nickname }}</span>
      <div class="loginOut">
        <svg-btn class="icon" :icon-class="iconName"></svg-btn>
        <div class="outItem" v-if="show" @click="loginOut()">
          <svg-btn class="icon" icon-class="icon-short-out"></svg-btn>
          <div class="font2">退出登录</div>
        </div>
      </div>
    </div>
    <fm-button class="loginBt" v-else type="primary" round size="small" @click="toLogin()"
      >登录/注册</fm-button
    >
  </div>
</template>

<script>
import { getUserInfoAPI, checkLoginAPI } from '@/axios/home'
import { loginOutAPI } from '@/axios/login'
export default {
  name: 'NavTopH',
  data() {
    return {
      show: false,
    }
  },
  computed: {
    iconName() {
      if (this.show) {
        return 'icon-short-up'
      } else {
        return 'icon-short-top'
      }
    },
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisiable)
    this.getUserInfo()
    this.$store.commit('setAttr', {
      name: 'getusercallback',
      val: this.getUserInfo,
    })
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  methods: {
    getUserInfo() {
      getUserInfoAPI()
        .then(res => {
          if (res.status == 1) {
            this.$store.commit('setAttr', {
              name: 'userInfo',
              val: res.data,
            })
            this.$store.commit('setAttr', {
              name: 'isLogin',
              val: 1,
            })
            localStorage.setItem('shortLogin', 1)
          }
        })
        .catch(err => {})
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case 'prerender':
          // console.log("网页预渲染，内容不可见");
          break
        case 'hidden':
          // console.log("内容不可见，处理后台、最小化、锁屏状态");
          break
        case 'visible':
          // console.log('页面可见')
          let isLogin = localStorage.getItem('shortLogin')
          if (isLogin && isLogin == 1) {
            //缓存提示登录了,但是vuex没更新的情况
            if (this.$store.state.isLogin == 0) {
              this.getUserInfo()
            }
            this.checkLogin()
          } else {
            //缓存提示没登录,但是vuex没更新的情况
            if (this.$store.state.isLogin == 1) {
              this.loginOut()
            }
          }
          // if (Number(localStorage.getItem('shortLogin')) !== 1) {
          //   this.getUserInfo()
          // }
          break
      }
    },
    //去主站短链页面
    toShort() {
      window.open(this.$glb.feemooUrl + '/shortChain', '_href')
    },
    checkLogin() {
      checkLoginAPI()
        .then(res => {})
        .catch(err => {})
    },
    toLogin() {
      this.$store.commit('setShowLoginShort', '/login')
      this.$store.commit('setShowLogin', true)
    },
    loginOut() {
      loginOutAPI({ is_cross: 1 })
        .then(res => {
          if (res.status == 1) {
            localStorage.removeItem('platfro')
            localStorage.removeItem('shortToken')
            localStorage.removeItem('shortLogin')
            this.$store.commit('clearUserData') //重置缓存
            this.$utils.clearCookie(this.$glb.fmCookieName)
            window.location.reload()
          }
        })
        .catch(err => {})
    },
  },
}
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  z-index: 999;
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: inset 0px -1px 0px 0px #efefef;
  .leftBox {
    display: flex;
    align-items: center;
    justify-content: center;
    .logo {
      width: 32px;
      height: 32px;
      margin-right: 6px;
    }
    .title {
      width: 74;
      height: 24px;
    }
  }
  .user {
    display: flex;
    align-items: center;
    .logo {
      width: 32px;
      height: 32px;
      object-fit: cover;
      border-radius: 50%;
    }
    .font1 {
      font-weight: 500;
      font-size: 12px;
      color: #2c2c2c;
      line-height: 16px;
      margin-left: 12px;
      margin-right: 8px;
      max-width: 136px;
      @include multiline(1);
    }
    .loginOut {
      position: relative;
      .icon {
        width: 12px;
        height: 12px;
      }
      .outItem {
        display: flex;
        width: 128px;
        height: 52px;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        position: absolute;
        top: 32px;
        right: -4px;
        z-index: 1200;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        .icon {
          width: 20px;
          height: 20px;
        }
        .font2 {
          font-weight: 400;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 20px;
          margin-left: 12px;
        }
      }
    }
  }
  .loginBt{
    padding: 0 12px;
  }
}
</style>
